import { Meeting } from '../services/meetingService';

/** How the Workshop tab should be organized for this member. */
export type WorkshopTabPhase = 'signup' | 'pre_start' | 'running';

export function getWorkshopTabPhase(
  registrationState: 'none' | 'interest' | 'confirmed',
  meeting: Meeting | null
): WorkshopTabPhase {
  if (registrationState !== 'confirmed') return 'signup';

  const dateStr = meeting?.workshop_first_session_date;
  if (!dateStr || !/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
    return 'pre_start';
  }

  const start = new Date(`${dateStr}T00:00:00`);
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return today >= start ? 'running' : 'pre_start';
}

export function isWorkshopStarted(meeting: Meeting | null): boolean {
  return getWorkshopTabPhase('confirmed', meeting) === 'running';
}
